import '../sass/main.scss';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelector('#menuToggle')?.addEventListener('click', (e) => {
		e?.currentTarget?.classList.toggle('active');
		document.getElementById('nav')?.classList.toggle('active');
	});
});
